import {Component, Input, OnInit} from '@angular/core';
import {NavItem} from '../../model/typings/nav.types';

@Component({
  selector: 'cpui-sub-nav',
  templateUrl: './sub-nav.component.html',
  styleUrls: ['./sub-nav.component.scss']
})
export class SubNavComponent implements OnInit {
  isExpanded = false;
  navItemList: NavItem[];

  @Input() blurSubNav = false;
  @Input() blurSubNavMobile = false;

  @Input('subNavList')
  set subNavList(navItemList: NavItem[]) {
    this.isExpanded = false;

    this.navItemList = navItemList;
  }

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/sub-nav/sub-nav.component.ts